"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const provider_components_1 = require("@kyruus/provider-components");
const styles_1 = require("./styles");
const location_address_1 = __importDefault(require("./location-address"));
const provider_hours_1 = __importDefault(require("./provider-hours"));
const location_accessibility_1 = __importDefault(require("./location-accessibility"));
const provider_contact_1 = __importDefault(require("./provider-contact"));
const with_error_boundary_1 = require("../ErrorFallback/with-error-boundary");
const Location = ({ location, mloc, config, getLocationUrl, locationCallback }) => {
    const locationMicrodata = (() => {
        let isHospital = false;
        let isClinic = false;
        if (location.name) {
            isHospital = location.name.toLowerCase().indexOf('hospital') !== -1;
            isClinic = location.name.toLowerCase().indexOf('clinic') !== -1;
        }
        if (isHospital) {
            return {
                itemProp: 'hospitalAffiliation',
                itemScope: true,
                itemType: 'https://schema.org/Hospital'
            };
        }
        if (isClinic) {
            return {
                itemScope: true,
                itemType: 'https://schema.org/MedicalClinic'
            };
        }
        return {
            itemScope: true,
            itemType: 'https://schema.org/MedicalOrganization'
        };
    })();
    return (react_1.default.createElement(styles_1.LocationWrapper, Object.assign({}, locationMicrodata, { className: "provider-profile-provider-location" }),
        react_1.default.createElement(provider_components_1.LocationLink, { location: location, getLocationUrl: getLocationUrl, locationCallback: locationCallback }, location.name),
        react_1.default.createElement(styles_1.LocationRow, { itemProp: "address", itemScope: true, itemType: "https://schema.org/PostalAddress" },
            react_1.default.createElement(location_address_1.default, { location: location, config: config })),
        react_1.default.createElement(styles_1.LocationRow, null,
            react_1.default.createElement(provider_contact_1.default, { location: location, contactType: 'phone' }),
            react_1.default.createElement(provider_contact_1.default, { location: location, contactType: 'fax' }),
            mloc && mloc.hours_of_operation ? (react_1.default.createElement(provider_hours_1.default, { periods: mloc.hours_of_operation.periods })) : null),
        react_1.default.createElement(styles_1.LocationRow, null,
            react_1.default.createElement(location_accessibility_1.default, { location: location }))));
};
exports.default = (0, with_error_boundary_1.withErrorBoundary)(Location);
//# sourceMappingURL=location.js.map